import { Select, message, Modal, Input, Checkbox, Row, Spin, Button } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import './index.less'
import labelApi from '@/api/label'
import ModalHeader from '@/components/ModalBase/ModalHeader'
import { useAppStore } from '@/store'
import { useObserver } from 'mobx-react'

interface ILabel {
  labelName: string
  id: number
  show?: boolean
}

const AddToLabel = () => {
  const [loadingObj, setLoadingObj] = useState({ listLoading: false, createLabelLoading: false, submitLoading: false })
  const [labelIdList, setLabelIdList] = useState<number[]>([])
  const [labelList, setLabelList] = useState<ILabel[]>([])
  const [searchVal, setSearchVal] = useState('')
  const [newLabelName, setNewLabelName] = useState('')
  const [errorTip, setErrorTip] = useState('')

  const appStore = useAppStore()

  useEffect(() => {
    if (appStore.isShowAddToLabel && appStore.labelActiveFaxLog) {
      // 获取列表
      getLabelList()
      // 设置默认
      setLabelIdList(appStore.labelActiveFaxLog.labelIdList)
    } else {
      setSearchVal('')
      setNewLabelName('')
      setLoadingObj({ listLoading: false, createLabelLoading: false, submitLoading: false })
    }
  }, [appStore.isShowAddToLabel, appStore.labelActiveFaxLog])

  //获取列表
  const getLabelList = async () => {
    setLoadingObj({ ...loadingObj, listLoading: true })
    const list = await labelApi.getLabelList().finally(() => {
      setLoadingObj({ ...loadingObj, listLoading: false })
    })
    setLabelList(list as ILabel[])
  }

  const onCancel = () => {
    setLabelIdList([])
    appStore.closeAddToLabel()
  }

  //提交
  const handleConfirm = async () => {
    const { labelActiveFaxLog: faxLog } = appStore
    if (!faxLog) {
      return
    }
    setLoadingObj({ ...loadingObj, submitLoading: true })
    await labelApi.addFaxToLabel(faxLog.id, labelIdList).finally(() => {
      setLoadingObj({ ...loadingObj, submitLoading: false })
    })
    message.success(`Added successfully`)
    onCancel()
  }

  //添加标签
  const handleAddLabel = () => {
    const has = labelList.some((it) => it.labelName === newLabelName)
    if (has) {
      setErrorTip('The label name you have chosen already exists. Please try another name.')
      return
    }
    setLoadingObj({ ...loadingObj, createLabelLoading: true })
    labelApi
      .addLabel(newLabelName)
      .then((id) => {
        message.success(`Created successfully`)
        setLabelList([...labelList, { id: id as number, labelName: newLabelName, show: true }])
        setLabelIdList([...labelIdList, id as number])
        setNewLabelName('')
      })
      .finally(() => {
        setLoadingObj({ ...loadingObj, createLabelLoading: false })
      })
  }

  //过滤搜索结果
  const searchLabelList = useMemo(() => {
    const list = labelList.slice()
    list.forEach((it) => {
      if (it.labelName.includes(searchVal)) {
        it.show = true
      } else {
        it.show = false
      }
    })
    return list
  }, [searchVal, labelList])

  return useObserver(() => (
    <Modal
      title=""
      className="diy-ant-modal"
      visible={appStore.isShowAddToLabel}
      okText="Confirm"
      closable={false}
      maskClosable={false}
      confirmLoading={loadingObj.submitLoading}
      onOk={handleConfirm}
      onCancel={onCancel}
      destroyOnClose
    >
      <ModalHeader title="Label as" onClose={onCancel} />
      <div style={{ padding: 24 }}>
        <Input.Search
          style={{ marginBottom: 16 }}
          value={searchVal}
          onChange={(e) => setSearchVal(e.target.value)}
          allowClear
          placeholder="search"
          onSearch={() => {}}
        />
        <Spin spinning={loadingObj.listLoading}>
          <Checkbox.Group
            className="label-checkout-group"
            value={labelIdList}
            onChange={(val) => setLabelIdList(val as number[])}
          >
            {searchLabelList.map((it) => {
              return (
                <Row
                  key={it.id}
                  style={{
                    display: it.show ? 'block' : 'none',
                    padding: '4px 0',
                    borderBottom: '1px solid #ededed',
                  }}
                >
                  <Checkbox style={{ width: '100%' }} value={it.id}>
                    {it.labelName}
                  </Checkbox>
                </Row>
              )
            })}
          </Checkbox.Group>
        </Spin>
        {/* 添加标签 */}
        <div className="flex" style={{ marginTop: 8 }}>
          <Input
            style={{ width: 200, marginRight: 8 }}
            placeholder="Label Name (64 char max)"
            onFocus={() => setErrorTip('')}
            value={newLabelName}
            maxLength={64}
            onInput={(e: any) => setNewLabelName(e.target.value)}
          ></Input>
          <Button
            onClick={handleAddLabel}
            disabled={!newLabelName || !!errorTip}
            loading={loadingObj.createLabelLoading}
          >
            Create New
          </Button>
        </div>
        <p className="l-error-tip">{errorTip}</p>
      </div>
    </Modal>
  ))
}

export default AddToLabel
